import { createStyleSheet2 } from './dom.js';
import { DisposableStore } from '../common/lifecycle.js';
import '../common/arrays.js';
import '../common/observableInternal/derived.js';
import { autorun } from '../common/observableInternal/autorun.js';
import '../common/observableInternal/utils.js';
import '../common/cancellation.js';
function createStyleSheetFromObservable(css) {
    const store = ( new DisposableStore());
    const w = store.add(createStyleSheet2());
    store.add(autorun(reader => {
        w.setStyle(css.read(reader));
    }));
    return store;
}
export { createStyleSheetFromObservable };
